module.exports = __webpack_public_path__ + "assets/img/ce12ddc298be59ab1a669b741834c1d9.svg";